export default __webpack_public_path__ + "static/media/twokitty-present.ea50331d.png";